import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import '../../assets/css/header.scss';

const Header = (props) => {
  return (
    <div className="header f0">
      {props.icon && (
        <FontAwesomeIcon className="cursor" onClick={props.goBack} color='var(--card-subtitle-color)' size={'sm'} icon={props.icon} />
      )}
      <span className="header-text card-font-color">{props.text}</span>
    </div>
  );
};

export default Header;
